import { z } from 'zod';
import { eventSchema } from './envelope';

export const SHIFT_HANDOVER_SUBMITTED_V1 = 'shift_handover.handover.submitted.v1' as const;
export const SHIFT_HANDOVER_DUE_V1 = 'shift_handover.handover.due.v1' as const;

/** Een ploeg diende haar overdracht in. Aantallen, geen tekst: de inhoud leest men in de app. */
export const handoverSubmittedV1Schema = eventSchema({
  handoverId: z.guid(),
  lineId: z.guid(),
  slotId: z.guid(),
  shiftDate: z.string(),
  openItems: z.number().int(),
  stoppedAssets: z.number().int(),
  faultAssets: z.number().int(),
});
export type HandoverSubmittedV1 = z.infer<typeof handoverSubmittedV1Schema>;

/**
 * De volgende ploeg begint: tijd om de overdracht te lezen.
 *
 * Met de ontvangers erin, omdat `notifications` de ploeg niet zelf kan uitrekenen (ADR-0021), en
 * met de zin van de strook ("Overdracht van de Late ploeg — Lijn 3 · 2 open punten · 1 machine
 * stil"). Dat is meer dan ADR-0038 toelaat voor een bericht, en het mag hier: het gaat over
 * machines en een lijn, niet over een persoon (ADR-0074).
 */
export const handoverDueV1Schema = eventSchema({
  handoverId: z.guid(),
  lineId: z.guid(),
  text: z.string(),
  recipientIds: z.array(z.guid()),
});
export type HandoverDueV1 = z.infer<typeof handoverDueV1Schema>;

export const shiftHandoverEventCatalog = {
  [SHIFT_HANDOVER_SUBMITTED_V1]: handoverSubmittedV1Schema,
  [SHIFT_HANDOVER_DUE_V1]: handoverDueV1Schema,
} as const;
